import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export class AuthRestfulService {
  private axiosInstance: AxiosInstance;

  constructor() {
    const apiUrl = import.meta.env.VITE_API_URL;
    this.axiosInstance = axios.create({
      baseURL: apiUrl,
      withCredentials: true,
    });
  }

  private async request(
    method: "get" | "post",
    instance: AxiosInstance,
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<any> {
    try {
      const response: AxiosResponse = await instance.request({
        method,
        url,
        data,
        ...config,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  protected async doGet(
    url: string,
    params?: any,
    config?: AxiosRequestConfig
  ): Promise<any> {
    return this.request("get", this.axiosInstance, url, null, {
      ...config,
      params,
    });
  }

  protected async doPost(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<any> {
    return this.request("post", this.axiosInstance, url, data, config);
  }
}
